<template>
  <component
    ref="linkRef"
    v-if="value?.proposalName"
    :is="isLink ? 'a' : 'span'"
    v-bind="
      isLink
        ? {
            href: linkForProposal,
            target: '_blank',
            rel: 'noopener noreferrer',
          }
        : {}
    "
    class="proposal-name-link"
    v-html="highlight()"
    draggable="false"
    @click="handleClick($event)"
  />
</template>

<script>
import { highlightSubstring } from "@/utils/highlightSubstring";
import { exceptionSelectionMixin } from "@/mixins/exceptionSelectionMixin";

export default {
  name: "ProposalNameCell",
  mixins: [exceptionSelectionMixin],
  props: ["value", "row", "column"],

  methods: {
    highlight() {
      return highlightSubstring(
        this.value?.proposalName,
        this.currentTab?.searchCriteria?.keyWords || "",
      );
    },

    handleClick(e) {
      const selection = window.getSelection();
      if (selection && selection.toString().trim().length > 0) {
        e.preventDefault();
      }
    },
  },

  computed: {
    isLink() {
      return this.$store.getters["auth/authorities"]?.includes(
        "ROLE_SUBSCRIBED_USER",
      );
    },

    linkForProposal() {
      const value = {
        ...this.row.proposalNumber,
        proposalSource: this.row.proposalSource,
      };

      if (!value || typeof value !== "object") {
        return "#";
      }

      const { url, proposalSource, proposalNumber } = value;

      if (!url) {
        return "#";
      }

      try {
        const newUrl = new URL(url);

        const sources = [
          "https://sapsrm.beloil.by",
          "https://zakupki.minsktrans.by",
          "https://belaruskali.by",
          "https://belarus-tr.gazprom.ru",
        ];

        if (sources.includes(proposalSource) && proposalNumber) {
          newUrl.searchParams.append("number", proposalNumber);
        }

        return newUrl.href;
      } catch (e) {
        console.warn("Invalid proposal URL:", value, e);
        return "#";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.proposal-name-link {
  color: rgb(55, 71, 79);
  cursor: text;
  user-select: text;

  &::selection {
    background-color: #4766cb;
    color: #fff;
  }

  &:visited {
    color: rgb(159, 173, 181);
  }
}
</style>
